import { ADD_BREADCRUMB, REMOVE_BREADCRUMB, RESET_BREADCRUMBS, SET_BREADCRUMBS } from 'reducers/actions-types';

export default function breadcrumbsReducer(state = {
    /** @type {IBreadcrumb[]} */
    items: [],
}, { type, breadcrumb, breadcrumbs }) {
    switch (type) {
        case RESET_BREADCRUMBS:
            return Object.assign({}, state, { items: [] });
        case SET_BREADCRUMBS:
            return Object.assign({}, state, { items: [...breadcrumbs] });
        case ADD_BREADCRUMB:
            return Object.assign({}, state, { items: [...state.items, breadcrumb] });
        case REMOVE_BREADCRUMB:
            return Object.assign({}, state, {
                items: state.items.reduce((acc, item) => {
                    if (item.url !== breadcrumb.url) {
                        acc.push(item);
                    }
                    return acc;
                }, []),
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/breadcrumbs/index.js